import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { MatchingAnalyticsActions } from './matching-analytics.actions';
import { AuthActions } from '@app/store/auth/auth.actions';
import { MatchingAnalyticsApiService } from '@app/core/api/matching-analytics';
import { LoggerService } from '@app/core/infrastructure';

@Injectable()
export class MatchingAnalyticsEffects {
  private readonly actions$ = inject(Actions);
  private readonly matchingApi = inject(MatchingAnalyticsApiService);
  private readonly logger = inject(LoggerService).scope('MatchingAnalyticsEffects');

  loadOverview$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MatchingAnalyticsActions.loadOverview),
      switchMap(({ params }) =>
        this.matchingApi.getOverview(params).pipe(
          map(overview => MatchingAnalyticsActions.loadOverviewSuccess({ overview })),
          catchError(error => {
            this.logger.error('Load matching overview failed:', error);
            return of(MatchingAnalyticsActions.loadOverviewFailure({ error: error.message }));
          })
        )
      )
    )
  );

  clearOnLogout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.logout),
      map(() => MatchingAnalyticsActions.clearMatchingAnalyticsState())
    )
  );
}
